import { Areas } from '@Pages/setting';
import * as S from './state';
import { toggle, unique } from '@Util/util';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import queryString from 'query-string';

const setState = () => {
    const query = queryString.parse(location.search);
    const areafQuery = 'area_ids[]' in query ? [].concat(query['area_ids[]']) : [];
    const prefQuery = 'prefecture_codes[]' in query ? [].concat(query['prefecture_codes[]']) : [];

    if (!Areas)
        return {
            openAreas: [],
            areas: {
                areas: [],
                prefectures: [],
            },
        };

    const areaPrefectures = Areas.flatMap((a) =>
        areafQuery.includes(String(a.id)) ? a.prefectures.map((p) => p.code) : []
    );
    prefQuery.push(...areaPrefectures);

    const hasAreas = Areas.flatMap((a) => {
        return !a.prefectures.filter((p) => !prefQuery.includes(p.code)).length ? a.key : [];
    });
    const openAreas = Areas.flatMap((a) => {
        return a.prefectures.filter((p) => !prefQuery.includes(p.code)).length < a.prefectures.length ? a.key : [];
    });

    return {
        openAreas: openAreas,
        areas: {
            areas: hasAreas,
            prefectures: prefQuery,
        },
    };
};

export const AreaState: S.AreaState = setState();

export type AreaActionTypes =
    | { type: 'SELECT_AREA'; payload: string }
    | { type: 'SELECT_PREFECTURE'; payload: string }
    | { type: 'TOGGLE_AREA'; payload: string }
    | { type: 'RESET'; payload: S.AreaState };

export const AreaReducer = (state: S.AreaState, action: AreaActionTypes): S.AreaState => {
    switch (action.type) {
        case 'RESET':
            return { ...action.payload };
        case 'TOGGLE_AREA':
            return {
                ...state,
                openAreas: state.openAreas.includes(action.payload)
                    ? state.openAreas.filter((a) => a !== action.payload)
                    : [...state.openAreas, action.payload],
            };
        case 'SELECT_AREA': {
            const areaData = Areas.find((a) => a.key === action.payload);
            if (!areaData) {
                return state;
            }
            const areaDataPrefKeys = areaData.prefectures.map((p) => p.code);
            const areas = state.areas.areas;
            const hasArea = areas.includes(action.payload);
            return {
                ...state,
                openAreas: hasArea ? state.openAreas : state.openAreas.concat(action.payload),
                areas: {
                    ...state.areas,
                    areas: toggle(state.areas.areas, action.payload),
                    prefectures: hasArea
                        ? state.areas.prefectures.filter((p) => !areaDataPrefKeys.includes(p))
                        : unique(state.areas.prefectures.concat(areaDataPrefKeys)),
                },
            };
        }
        case 'SELECT_PREFECTURE': {
            const currentPrefs = state.areas.prefectures;
            const area = Areas.find((a) => a.prefectures.some((p) => p.code === action.payload));
            if (!area) {
                return state;
            }
            if (state.areas.areas.includes(area.key)) {
                return {
                    ...state,
                    areas: {
                        ...state.areas,
                        areas: toggle(state.areas.areas, area.key),
                        prefectures: toggle(currentPrefs, action.payload),
                    },
                };
            }
            const newPrefs = toggle(currentPrefs, action.payload);
            const areaPrefs = area.prefectures.map((p) => p.code);
            return {
                ...state,
                areas: {
                    ...state.areas,
                    areas: areaPrefs.every((p) => newPrefs.includes(p))
                        ? state.areas.areas.concat(area.key)
                        : state.areas.areas,
                    prefectures: newPrefs,
                },
            };
        }
    }
    return state;
};
